import {
  PARSING_JD,
  PARSING_JD_SUCCESSFUL,
  PARSING_JD_FAILED,
  ADD_JOB,
  ADD_JOB_SUCCESSFUL,
  ADD_JOB_FAILED,
  GET_JOB_DATA,
  GET_JOB_DATA_SUCCESSFUL,
  GET_JOB_DATA_FAILED,
  UPDATE_JOB,
  UPDATE_JOB_FAILED,
  UPDATE_JOB_SUCCESSFUL,
  GET_QUALIFICATION,
  GET_QUALIFICATION_SUCCESSFUL,
  GET_QUALIFICATION_FAILED,
  JOB_GET_IP_LOCATION,
  JOB_GET_IP_LOCATION_FAILED,
  JOB_GET_IP_LOCATION_SUCCESSFULL,
  GET_COUNTRIES,
  GET_COUNTRIES_FAILED,
  GET_COUNTRIES_SUCCESS,
  GET_STATE,
  GET_STATE_FAILED,
  GET_STATE_SUCCESS,
  GET_ORGANIZATION_DETAIL_JOB,
  GET_ORGANIZATION_DETAIL_SUCCESS,
  GET_ORGANIZATION_DETAIL_FAILED,
  GET_TAXONOMY_JOBPROFILE,
  GET_TAXONOMY_JOBPROFILE_FAILED,
  GET_TAXONOMY_JOBPROFILE_SUCCESS,
  GET_TAXONOMY_JOBDESCRIPTION,
  GET_TAXONOMY_JOBDESCRIPTION_FAILED,
  GET_TAXONOMY_JOBDESCRIPTION_SUCCESS,
  GET_TAXONOMY_JOBSKILL,
  GET_TAXONOMY_JOBSKILL_FAILED,
  GET_TAXONOMY_JOBSKILL_SUCCESS,
  RECRUITER_ORGANIZATION_DETAIL_GET_LIST_FAILED,
  RECRUITER_ORGANIZATION_DETAIL_GET_LIST_SUCCESSFULL,
  RECRUITER_ORGANIZATION_DETAIL_GET_LIST,
  BULK_IMPORT_SUGGESTION,
  BULK_IMPORT_SUGGESTION_SUCCESS,
  BULK_IMPORT_SUGGESTION_ERROR,
  ADD_LOCATION_FAILED,
  ADD_LOCATION_SUCCESSFUL,
  ADD_LOCATION,
  GET_JOB_INDUSTRIES,
  GET_JOB_INDUSTRIES_SUCCESS,
  GET_JOB_INDUSTRIES_FAILED,
  GET_JOB_DEGREES,
  GET_JOB_DEGREES_SUCCESS,
  GET_JOB_DEGREES_FAILED,
} from "./actionTypes";

export const parsingJd = (user) => {
  return {
    type: PARSING_JD,
    payload: { user },
  };
};

export const parsingJdSuccessful = (user) => {
  return {
    type: PARSING_JD_SUCCESSFUL,
    payload: user,
  };
};

export const parsingJdFailed = (user) => {
  return {
    type: PARSING_JD_FAILED,
    payload: user,
  };
};
export const addNewJobs = (user) => {
  return {
    type: ADD_JOB,
    payload: { user },
  };
};

export const addJobSuccessful = (user) => {
  return {
    type: ADD_JOB_SUCCESSFUL,
    payload: user,
  };
};

export const addJobFailed = (user) => {
  return {
    type: ADD_JOB_FAILED,
    payload: user,
  };
};
export const getJobsData = (user) => {
  return {
    type: GET_JOB_DATA,
    payload: { user },
  };
};

export const getJobsDataSuccessful = (user) => {
  return {
    type: GET_JOB_DATA_SUCCESSFUL,
    payload: user,
  };
};

export const getJobsDataFailed = (user) => {
  return {
    type: GET_JOB_DATA_FAILED,
    payload: user,
  };
};
export const UpdateJobs = (user) => {
  return {
    type: UPDATE_JOB,
    payload: { user },
  };
};

export const UpdateJobSuccessful = (user) => {
  return {
    type: UPDATE_JOB_SUCCESSFUL,
    payload: user,
  };
};

export const UpdateJobFailed = (user) => {
  return {
    type: UPDATE_JOB_FAILED,
    payload: user,
  };
};
export const getQualification = (user) => {
  return {
    type: GET_QUALIFICATION,
    payload: { user },
  };
};

export const getQualificationSuccessful = (user) => {
  return {
    type: GET_QUALIFICATION_SUCCESSFUL,
    payload: user,
  };
};

export const getQualificationFailed = (user) => {
  return {
    type: GET_QUALIFICATION_FAILED,
    payload: user,
  };
};
//GET COUNTRY AND STATE ON IP BASED FUNCTIONS
export const jobGetIpBasedLocation = (iplocation) => {
  return {
    type: JOB_GET_IP_LOCATION,
    payload: { iplocation },
  };
};
export const jobGetIpBasedLocationSuccess = (iplocation) => {
  return {
    type: JOB_GET_IP_LOCATION_SUCCESSFULL,
    payload: iplocation,
  };
};
export const jobGetIpBasedLocationError = (iplocation) => {
  return {
    type: JOB_GET_IP_LOCATION_FAILED,
    payload: iplocation,
  };
};

//get country
export const getCountries = (user) => {
  return {
    type: GET_COUNTRIES,
    payload: { user },
  };
};
export const setCountriesFailed = (user) => {
  return {
    type: GET_COUNTRIES_FAILED,
    payload: { user },
  };
};
export const setCountriesSuccess = (user) => {
  return {
    type: GET_COUNTRIES_SUCCESS,
    payload: { user },
  };
};
//get state
export const getState = (user) => {
  return {
    type: GET_STATE,
    payload: { user },
  };
};
export const setStateFailed = (user) => {
  return {
    type: GET_STATE_FAILED,
    payload: { user },
  };
};
export const setStateSuccess = (user) => {
  return {
    type: GET_STATE_SUCCESS,
    payload: { user },
  };
};

export const getOrganizationDetail = (user) => {
  return {
    type: GET_ORGANIZATION_DETAIL_JOB,
    payload: { user },
  };
};

export const setOrganizationDetailSuccess = (user) => {
  return {
    type: GET_ORGANIZATION_DETAIL_SUCCESS,
    payload: { user },
  };
};
export const setOrganizationFailed = (user) => {
  return {
    type: GET_ORGANIZATION_DETAIL_FAILED,
    payload: { user },
  };
};
export const getTaxonomyJobProfile = (user) => {
  return {
    type: GET_TAXONOMY_JOBPROFILE,
    payload: { user },
  };
};

export const getTaxonomyJobProfileSuccess = (user) => {
  return {
    type: GET_TAXONOMY_JOBPROFILE_SUCCESS,
    payload: user,
  };
};

export const getTaxonomyJobProfileFailed = (user) => {
  return {
    type: GET_TAXONOMY_JOBPROFILE_FAILED,
    payload: user,
  };
};
export const getTaxonomyJobDescription = (user) => {
  return {
    type: GET_TAXONOMY_JOBDESCRIPTION,
    payload: { user },
  };
};

export const getTaxonomyJobDescriptionSuccess = (user) => {
  return {
    type: GET_TAXONOMY_JOBDESCRIPTION_SUCCESS,
    payload: user,
  };
};

export const getTaxonomyJobDescriptionFailed = (user) => {
  return {
    type: GET_TAXONOMY_JOBDESCRIPTION_FAILED,
    payload: user,
  };
};

export const getTaxonomyJobSKill = (user) => {
  return {
    type: GET_TAXONOMY_JOBSKILL,
    payload: { user },
  };
};

export const getTaxonomyJobSKillSuccess = (user) => {
  return {
    type: GET_TAXONOMY_JOBSKILL_SUCCESS,
    payload: user,
  };
};

export const getTaxonomyJobSKillFailed = (user) => {
  return {
    type: GET_TAXONOMY_JOBSKILL_FAILED,
    payload: user,
  };
};
//get organization list
export const getRecruiterOrganizationList = (organizationDetail) => {
  return {
    type: RECRUITER_ORGANIZATION_DETAIL_GET_LIST,
    payload: { organizationDetail },
  };
};
export const getRecruiterOrganizationListSuccess = (organizationDetail) => {
  return {
    type: RECRUITER_ORGANIZATION_DETAIL_GET_LIST_SUCCESSFULL,
    payload: { organizationDetail },
  };
};
export const getRecruiterOrganizationListError = (organizationDetail) => {
  return {
    type: RECRUITER_ORGANIZATION_DETAIL_GET_LIST_FAILED,
    payload: { organizationDetail },
  };
};

// update mapped candidates Status
export const getBulkImportSuggestion = (jobBulkId) => {
  return {
    type: BULK_IMPORT_SUGGESTION,
    payload: { jobBulkId },
  };
};
export const getBulkImportSuggestionSuccess = (jobProfile) => {
  return {
    type: BULK_IMPORT_SUGGESTION_SUCCESS,
    payload: { jobProfile },
  };
};
export const getBulkImportSuggestionFailed = (jobProfile) => {
  return {
    type: BULK_IMPORT_SUGGESTION_ERROR,
    payload: { jobProfile },
  };
};
export const addNewLocation = (user) => {
  return {
    type: ADD_LOCATION,
    payload: { user },
  };
};

export const addLocationSuccessful = (user) => {
  return {
    type: ADD_LOCATION_SUCCESSFUL,
    payload: user,
  };
};

export const addLocationFailed = (user) => {
  return {
    type: ADD_LOCATION_FAILED,
    payload: user,
  };
};

export const getJobIndustries = (user) => {
  return {
    type: GET_JOB_INDUSTRIES,
    payload: user,
  };
};

export const getJobIndustriesSuccess = (user) => {
  return {
    type: GET_JOB_INDUSTRIES_SUCCESS,
    payload: user,
  };
};

export const getJobIndustriesFailed = (error) => {
  return {
    type: GET_JOB_INDUSTRIES_FAILED,
    payload: error,
  };
};

export const getJobDegrees = (user) => {
  return {
    type: GET_JOB_DEGREES,
    payload: user,
  };
};

export const getJobDegreesSuccess = (user) => {
  return {
    type: GET_JOB_DEGREES_SUCCESS,
    payload: user,
  };
};

export const getJobDegreesFailed = (error) => {
  return {
    type: GET_JOB_DEGREES_FAILED,
    payload: error,
  };
};
